import React from 'react';
import css from './SignupForm.module.css';
import { FieldPhoneNumberInput, FieldTextInput } from '../../../components';
import { composeValidators, required } from '../../../util/validators';
import classNames from 'classnames';
const AgencyFormInputFields = ({
  intl,
  formId,
  emailRequired,
  emailFormatValid,
  isEditListingDetailsForm,
  handleBioChange,
  remainingChars,
  bio,
}) => {
  return (
    <>
      <div className={css.formRow}>
        <FieldTextInput
          className={css.formFld}
          type="email"
          id={formId ? `${formId}.email` : 'email'}
          name="email"
          autoComplete="email"
          label={intl.formatMessage({
            id: 'AgencyFormInputFields.emailLabel',
          })}
          placeholder={intl.formatMessage({
            id: 'AgencyFormInputFields.emailPlaceholder',
          })}
          validate={composeValidators(emailRequired, emailFormatValid)}
          disabled={isEditListingDetailsForm}
        />
        <FieldTextInput
          className={css.formFld}
          type="text"
          id={formId ? `${formId}.agencyName` : 'agencyName'}
          name="agencyName"
          autoComplete="family-name"
          label={intl.formatMessage({
            id: 'AgencyFormInputFields.agencyNameLabel',
          })}
          placeholder={intl.formatMessage({
            id: 'AgencyFormInputFields.agencyNamePlaceholder',
          })}
          validate={required(
            intl.formatMessage({
              id: 'AgencyFormInputFields.agencyNameRequired',
            })
          )}
        />
      </div>
      <div className={css.formRow}>
        <FieldTextInput
          className={css.formFld}
          type="text"
          id={formId ? `${formId}.firstName` : 'firstName'}
          name="firstName"
          autoComplete="given-name"
          label={intl.formatMessage({
            id: 'AgencyFormInputFields.agencyFirstNameLabel',
          })}
          placeholder={intl.formatMessage({
            id: 'AgencyFormInputFields.agencyFirstNamePlaceholder',
          })}
          validate={required(
            intl.formatMessage({
              id: 'AgencyFormInputFields.agencyFirstNameRequired',
            })
          )}
        />

        <FieldTextInput
          className={css.formFld}
          type="text"
          id={formId ? `${formId}.lastName` : 'lastName'}
          name="lastName"
          autoComplete="family-name"
          label={intl.formatMessage({
            id: 'AgencyFormInputFields.agencyLastNameLabel',
          })}
          placeholder={intl.formatMessage({
            id: 'AgencyFormInputFields.agencyLastNamePlaceholder',
          })}
          validate={required(
            intl.formatMessage({
              id: 'AgencyFormInputFields.agencyLastNameRequired',
            })
          )}
        />
      </div>
      <div className={css.formRow}>
        <FieldTextInput
          className={css.formFld}
          type="text"
          id={formId ? `${formId}.contactJobTitle` : 'contactJobTitle'}
          name="contactJobTitle"
          autoComplete="family-name"
          label={intl.formatMessage({
            id: 'AgencyFormInputFields.agencycontactJobTitleLabel',
          })}
          placeholder={intl.formatMessage({
            id: 'AgencyFormInputFields.agencycontactJobTitlePlaceholder',
          })}
          validate={required(
            intl.formatMessage({
              id: 'AgencyFormInputFields.agencycontactJobTitleRequired',
            })
          )}
        />
        <FieldPhoneNumberInput
          className={css.formFld}
          type="text"
          id={formId ? `${formId}.phoneNumber` : 'phoneNumber'}
          name="phoneNumber"
          label={intl.formatMessage({
            id: `AgencyFormInputFields.contactPhoneNumberLabel`,
          })}
          placeholder={intl.formatMessage({
            id: `AgencyFormInputFields.contactPhoneNumberPlaceholder`,
          })}
          validate={required(
            intl.formatMessage({
              id: 'AgencyFormInputFields.contactPhoneNumberRequired',
            })
          )}
        />
      </div>
      <div className={classNames(css.formRow, css.fullWidth)}>
        <FieldTextInput
          id={`${formId}description`}
          name="description"
          className={css.description}
          type="textarea"
          label={intl.formatMessage({ id: 'AgencyFormInputFields.description' })}
          placeholder={intl.formatMessage({
            id: 'AgencyFormInputFields.descriptionPlaceholder',
          })}
          validate={required(
            intl.formatMessage({
              id: 'AgencyFormInputFields.descriptionRequired',
            })
          )}
          value={bio}
          onChange={handleBioChange}
        />
        <div
          className={classNames(css.characterCount, {
            [css.warning]: remainingChars < 10 && remainingChars > 0,
            [css.limitReached]: remainingChars === 0,
          })}
        >
          {remainingChars}{' '}
          {intl.formatMessage({
            id: 'SignupForm.descriptionCharactersLeft',
          })}
        </div>
      </div>
    </>
  );
};

export default AgencyFormInputFields;
